<script>
  import axios from "axios"
  import ApplicationState from "../../../Stores/applicationStates"
  import Navbar from "../../../Shared/Navbar/index.svelte"
  import Footer from "../../../Shared/footer.svelte"
  import notify from "../../../Script/notify"
  import Table from "../../../Shared/Table/table.svelte"
  import List from "./Components/list.svelte"
  import FilterComponent from "./Components/filterComponent.svelte"
  import { onMount } from "svelte"
  import LoadingScreen from "../../Publish/SinglePublish/Components/loadingScreen.svelte"
  import { querystring, push } from "svelte-spa-router"
  import { queryStringToJSON } from "../../../Script/queryString"
  import { fetchBadgeList } from "../../Publish/Badge/Script/api"
  import { getRequest } from "../../../Script/apiMethods"
  let query = queryStringToJSON($querystring)

  /**
   * @type {Boolean} - whether to disable next button or not
   */
  let apiCallBtnDisable = false

  /**
   * @type {Number} - how many list need to show
   */
  let limit

  /**
   * @type {Number} - which page list need to show
   */
  let page

  /**
   * @type {Number} - which order need to show (in order to date)
   */
  let sort

  /**
   * @type {Number} -which sory type need to show (date or name)
   */
  let sortBy

  /**
   * @typedef {Object} search - it contains what user want to search (searchvalue) in which parameter (searchParam)
   * @type {Object}
   * it contains what user want to search (searchvalue) in which parameter (searchParam)
   *
   * @property {String} searchvalue - what value need to search.
   * @property {String} searchParam - on which param need to show
   */
  let search = {
    searchParam: "name",
    searchvalue: "",
  }

  /**
   * @type {String} - from date of filter list
   */
  let startDate = null

  /**
   * @type {String} - to date of filter list
   */
  let endDate = null

  /**
   * @type {String} - which state document need to show
   */
  let status = null

  /**
   * @type {Object} - response for fetch document api call
   */
  let DocumentList = {
    badges: [],
  }

  onMount(async () => {
    try {
      limit = query.limit ? query.limit : 10
      page = query.page ? query.page : 1
      sort = query.sort ? query.sort : -1
      sortBy = query.sortBy ? query.sortBy : "date"
      startDate = query.sdate ? query.sdate : ""
      endDate = query.edate ? query.edate : ""
      status = query.state ? query.state : "all"
      search.searchParam = query.sin ? query.sin : "name"
      search.searchvalue = query.sname ? query.sname : ""
      await fetchList()
    } catch (error) {
      const info = "PAGE: Badge List\nEVENT: onMount"
      notify.danger(error, info)
    }
  })

  /**
   * @description function for fetch publsih process documents.
   */
  const fetchList = async () => {
    try {
      apiCallBtnDisable = true
      // let data = await fetchBadgeList()
      const data = await getRequest(`/api/swagger/v2/badge?limit=${limit}&page=${page}&sort=${sort}&sortBy=${sortBy}${search.searchvalue ? `&sin=${search.searchParam}&sname=${search.searchvalue}` : ``}${startDate ? `&sdate=${startDate}` : ``}${endDate ? `&edate=${endDate}` : ``}`, {
        // ${status ? `&state=${status}` : ``}
        headers: {
          "x-access-token": $ApplicationState.token,
        },
      })
      // console.log(data)

      // console.log("Badge List", data)

      DocumentList = data
      push(`/documents/badge?limit=${limit}&page=${page}&sort=${sort}&sortBy=${sortBy}${search.searchvalue ? `&sin=${search.searchParam}&sname=${search.searchvalue}` : ``}${startDate ? `&sdate=${startDate}` : ``}${endDate ? `&edate=${endDate}` : ``}${status ? `&state=${status}` : ``}`)
    } catch (error) {
      throw error
    } finally {
      apiCallBtnDisable = false
    }
  }

  /**
   * @description Function to fetch templates based on user input.
   */
  const whileChangingEntries = async (e) => {
    try {
      if (e.detail.entries) limit = e.detail.entries
      if (e.detail.activePage) page = e.detail.activePage
      if (e.detail.sort) sort = e.detail.sort
      if (e.detail.sortBy) sortBy = e.detail.sortBy
      if (e.detail.filter.date.status) {
        status = e.detail.filter.date.status
        startDate = e.detail.filter.date.startDate ? e.detail.filter.date.startDate : ""
        endDate = e.detail.filter.date.endDate ? e.detail.filter.date.endDate : ""
      }
      if (e.detail.filter.search.searchParam) {
        search.searchParam = e.detail.filter.search.searchParam
        search.searchvalue = e.detail.filter.search.searchvalue
      }
      await fetchList()
    } catch (error) {
      const info = "PAGE: Badge List\nEVENT: Error occurred during actions such as sorting by date/ name, changing display entries,changing date filter, or navigating pages."
      notify.danger(error, info)
    }
  }

  /**
   * @description Function to reset the user inputs
   */
  const resetList = async () => {
    try {
      limit = 10
      page = 1
      sort = -1
      sortBy = "date"
      search.searchvalue = ""
      search.searchParam = "name"
      startDate = ""
      endDate = ""
      status = "all"
      await fetchList()
    } catch (error) {
      console.error(error)
      const info = "PAGE: Badge List\nEVENT: Error occurred while resetting filter."
      notify.danger(error, info)
    }
  }
</script>

<svelte:head>
  <title>Badges</title>
</svelte:head>

<div class="relative min-h-screen w-full overflow-hidden bg-[#f7f7f7] dark:bg-bodyblack">
  <Navbar />
  {#if apiCallBtnDisable}
    <LoadingScreen msg={"Fetching Badge list"} />
  {/if}
  <div class="px-6 pb-40 pt-3">
    <div class="relative mx-auto mt-8 h-full w-full max-w-[920px] rounded-md bg-[#f7f7f7] dark:bg-bodyblack">
      <Table on:changeEntries={whileChangingEntries} on:resetEntries={resetList} title={"List of Badges"} filterComponent={FilterComponent} count={DocumentList.count} jsonData={DocumentList.badges} filter={true}>
        {#if DocumentList.badges.length}
          {#each DocumentList.badges as json}
            <List {json} />
          {/each}
        {:else}
          <div class="text-secondary2 select-none rounded-md bg-white py-6 text-center text-xl dark:bg-darkgray dark:text-white sm:text-2xl">There is no Badge</div>
        {/if}
      </Table>
    </div>
  </div>

  <Footer />
</div>
